import src from "IMAGE";
export default { src, width: 650, height: 650, blurWidth: 0, blurHeight: 0};
